import { firebaseConfig, endPointUrl } from "../libs/fbConfig";
import app from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import { removeItem, setItem, getItem } from "../libs/encryptedStorage";
import { handoffSessionKey, isHandoffSession } from "../libs/handoffSession";
import { jwtDecode } from "jwt-decode";

import authHelper from "../okta/page"
const superagent = require("superagent");
import { oktaRedirectUrl } from "../libs/fbConfig";
import { endPoint } from "../libs/fbConfig";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import packageJson from "../../../package.json";
import { timeutil } from 'sharedresources';

function initMasterConfig() {
    try {
        return app.initializeApp(firebaseConfig);
    } catch (err) {
    }
};

function initSecondaryDb(schoolConfig, schoolName) {
    // const secondaryConfig = {
    //     clientId: schoolConfig.clientID,
    //     appId: schoolConfig.secondaryWebAppId,
    //     apiKey: schoolConfig.apiKey,
    //     databaseURL: schoolConfig.databaseUrl,
    //     storageBucket: schoolConfig.storageBucket,
    //     messagingSenderId: schoolConfig.gcmSenderID,
    //     projectId: schoolConfig.projectId,
    // };
    const secondaryConfig = {
        apiKey: schoolConfig.apiKey,
        authDomain: schoolConfig.authDomain,
        databaseURL: schoolConfig.databaseUrl,
        projectId: schoolConfig.projectId,
        storageBucket: schoolConfig.storageBucket,
        messagingSenderId: schoolConfig.messagingSenderId,
        appId: schoolConfig.appId
    }

    try {
        return app.app(schoolName);
    } catch (e) {
        return app.initializeApp(secondaryConfig, schoolName);
    }
}

// Signs in to the school's own Firebase project with a custom token minted by
// GET /settings/dbToken for the logged-in profile. The token is what the school database
// rules check, so the session can read only this school's /lastUpdate entries.
function loginSecondaryDb(secondaryApp, customToken) {
    return secondaryApp.auth().signInWithCustomToken(customToken).then(() => {
        console.log("secondaryDB logged in")
        return true;
    });
}

async function logout() {
    // A handoff session was never established through Auth0, so there is no Auth0 session
    // to end — and bouncing the parent through the Auth0 logout URL would take them off
    // the app. Drop the Firebase session and the stored keys instead, then land them back
    // on the public entry point the way the Auth0 logout redirect otherwise would.
    const handoffSession = isHandoffSession();
    if (!handoffSession) {
        let auth0 = authHelper.getauth0Instance(null)
        await auth0.logout({
            logoutParams: {
                returnTo: oktaRedirectUrl
            }
        });
    }
    initMasterConfig();
    clearLocalStorage();
    let promise = new Promise((resolve, reject) => {
        app.auth().signOut().then(res => {
            if (handoffSession && typeof window !== "undefined") {
                window.location.href = "/";
            }
            resolve(true)
        }).catch(err => {
            console.log("Failed to logout", err);
            reject(false);
        })
    });
    return promise;
}

function clearLocalStorage() {
    removeItem("user");
    removeItem("schoolConfig");
    removeItem("schoolName");
    removeItem("loggedInEncodedEmail");
    removeItem("teacher");
    removeItem("teacherList");
    removeItem("student");
    removeItem("userList");
    removeItem("accountList");
    removeItem("devMode")
    removeItem(handoffSessionKey)
}

function verifyPhoneNumber(numberWithCode, recaptcha) {
    try {
        window.recaptchaVerifier = new app.auth.RecaptchaVerifier(recaptcha, {
            size: "invisible",
            // 'size': 'normal',
            callback: function (response) {
                console.log("captcha response", response);
            },
            "expired-callback": function () { },
        });
        var promise = new Promise(function (resolve, reject) {
            app.auth()
                .signInWithPhoneNumber(numberWithCode, window.recaptchaVerifier)
                .then((confirmationResult) => {
                    resolve(confirmationResult);
                })
                .catch((error) => {
                    console.log("failed to send verification code", error.code);
                });
        });
        return promise;
    } catch (err) {
        console.log("failed to send verification code", err);
    }
}

function loginUsingPhoneNumber(confirmationResult, verificatonCode) {
    try {

        var promise = new Promise(function (resolve, reject) {
            confirmationResult
                .confirm(verificatonCode)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    console.log("failed to login with phone number", error.code);
                });
        });
        return promise;
    } catch (err) {
        console.log("failed to login with phone number", err);
    }
}

function loginWithGoogle() {
    try {
        var promise = new Promise(function (resolve, reject) {
            var provider = new app.auth.GoogleAuthProvider();
            provider.setCustomParameters({
                prompt: 'select_account'
            });
            provider.addScope('email');
            app.auth()
                .signInWithPopup(provider)
                .then((result: any) => {
                    if (result?.additionalUserInfo?.profile?.email) {
                        resolve(result);
                    } else {
                        reject("Email not found")
                    }
                })
                .catch((error) => {
                    reject("Email not found")
                })
        });
        return promise;
    } catch (err) {
        console.log("failed to login with google", err);
    }
}
function isTokenExpired(token) {
    var decoded = jwtDecode(token);
    if (decoded.exp.toString().length == 10) {
        decoded.exp = decoded.exp * 1000;
    } else {
        console.log("length is more than 10")
    }

    let isExpired = false;
    if (timeutil.getInstance(decoded.exp).subtract(10, 'minute').isBefore(timeutil.getInstance(), 'minutes')) {
        isExpired = true;
    };
    return isExpired;
}
function catchTokenError(err) {
    setTimeout(() =>
        logout()
        , 100);
}

function getAuthToken() {
    let existingToken = getItem("authToken");
    let isExpired = false;
    if (existingToken) {
        isExpired = isTokenExpired(existingToken);
    } else {
        isExpired = true;
    }



    let promise = new Promise(function (resolve, reject) {
        {/**test cases */ }
        // user not found
        // token expired
        // network error
        // other failure
        // reset password
        if (!isExpired && existingToken) { resolve(existingToken); return; };
        var unsubscribeListner = app.auth().onAuthStateChanged(user => {
            if (user) {
                user
                    .getIdToken(true)
                    .then(function (token) {
                        console.log("Token on interval-->", token);
                        resolve(token);
                        setItem("authToken", token);
                        unsubscribeListner();
                    }).catch((err) => {
                        if (err && err.code && err.code === "auth/network-request-failed") {
                            console.error("error in getting token on interval", err);
                            resolve(existingToken);
                        } else {
                            reject(err);
                            catchTokenError(err)
                        }
                    });
            } else {
                catchTokenError(new Error("User not found"))
            }
        });
    });
    return promise;
}

function signupAccount(email,
    password,
    countryCode,
    phoneNumber,
    name,
    address,
    companyName,
    currency,
    industry,
    confirmPassword,
    firebase,
    selectedGender,
    timezone
) {

    let userEmail = replaceAll(email, "@", "%40");
    let encodedEmail = replaceAll(userEmail, ".", "%2E");
    let signUpEndPointUrl = endPointUrl + "bookingoApi/signup/school";
    console.log("encoded email", encodedEmail);
    let obj = {
        address: address,
        email: email,
        companyName: companyName,
        countryCode: countryCode,
        phoneNumber: phoneNumber,
        password: password,
        confirmPassword,
        industry,
        currency,
        name: name,
        encodedEmail: encodedEmail,
        timezone,
        gender: selectedGender,
        platform: "web",
        updatedOn: timeutil.getEpoch()
    };
    let authToken: any
    // let db = app.database();
    var p1 = new Promise(function (resolve, reject) {
        superagent
            .post(signUpEndPointUrl)
            .send(obj)
            .set("accept", "json")
            .set({
                "Authorization": "Bearer " + authToken,
                "x-platform": "booking"
            })
            .end((err, res) => {
                if (res) {
                    resolve(res);
                }

                if (err) {
                    reject(err);
                }
            });
    });
    return p1;
}
function replaceAll(str, term, replacement) {
    return str.replace(new RegExp(escapeRegExp(term), "g"), replacement);
}


function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function initBugSnag(user?: any, centerId?: any) {
    if (endPoint == "production") {
        Bugsnag.start({
            apiKey: "ff4274e42cc6f33caf297968771a9342",
            plugins: [new BugsnagPluginReact()],
            appVersion: packageJson.version,
            releaseStage: "production",
            enabledReleaseStages: ["production"],
        });
    }
    if (endPoint == "production" && user) {
        Bugsnag.addMetadata(user, {
            email: user?.email || null,
            schoolName: centerId || null,
            userName: user?.name || null,
            phoneNumber: user?.phoneNumber || null
        })
        Bugsnag.setUser(user.id, (user?.email || (user?.phoneNumber || null), (user?.email || (user?.phoneNumber || null))))
    }
}

function login(data) {
    Object.keys(data).forEach(key => {
        setItem(key, data[key]);
    });
}

/**
 * Sign out of one school's named Firebase app.
 *
 * Each center gets its own named app via initSecondaryDb, signed in with a token
 * minted for that school. Leaving that session alive after moving to another
 * center means two schools' databases are reachable from the same tab, so the
 * God Mode switch flow tears the old one down before opening the next.
 *
 * The app itself is kept (Firebase cannot un-initialize a named app cheaply and
 * re-entering the same center reuses it); only the auth session is dropped.
 */
async function signOutSecondaryDb(centerId) {
    try {
        if (!centerId) return false;
        const secondaryApp = app.app(centerId);
        await secondaryApp.auth().signOut();
        return true;
    } catch (err) {
        // No such app, or it was never signed in — nothing to tear down.
        console.log("[signOutSecondaryDb] Nothing to sign out for", centerId, err);
        return false;
    }
}

function signInWithCustomToken(customToken) {
    return new Promise(function (resolve, reject) {
        app.auth()
            .signInWithCustomToken(customToken)
            .then((authUser) => {
                resolve(authUser);
            })
            .catch(function (error) {
                console.log("auth user not found", error);
                reject(error);
            });
    });
}

// Ends only this project's Firebase session. Unlike logout() it ends no Auth0 session,
// clears no storage and navigates nowhere — the handoff flow needs to undo its own
// sign-in when a later step fails, without tearing down anything around it.
function signOutMasterAuth() {
    return app.auth().signOut();
}



export const loginApi = {
    initMasterConfig,
    initSecondaryDb,
    loginSecondaryDb,
    logout,
    clearLocalStorage,
    verifyPhoneNumber,
    loginUsingPhoneNumber,
    loginWithGoogle,
    signupAccount,
    getAuthToken,
    initBugSnag,
    login,
    signInWithCustomToken,
    signOutSecondaryDb,
    signOutMasterAuth
}